/* eslint-disable require-atomic-updates */
// ********************************************************
// Security
// Handles stuff like user and login/logout.
// ********************************************************

import { app } from '@/main'
import Router from '@/router'
import * as Backend from '@/core/backend'
import moment from 'moment'
import { detectDefaultLand } from '@/core/lang'
// import * as Admin from '@/core/admin'
import * as LocalStorage from '@/core/local-storage'
import { UserDetail } from '@/core/userDetail'
import * as License from '@/core/license'
import * as Msal from 'msal'

export const user = {
  id: '00000000-0000-0000-0000-000000000000',
  loggedIn: false,
  token: null,
  corporation: null,
  corporationDetails: null,
  userDetails: null,
  name: null,
  fullName: null
}
export const maxInactiveSec = 12 * 60 * 60 // 12 hours. Consider: Should we be able to set this per user?
export let lastActiveTime = Date.now()
export let autoLogOutTimer = null
export let keepAliveTimer = null
export let goToDirectPath = null // temporarly store direct path links, and go to direct path instead of saved path in loadUserPath
export let EnterPinCode = false
export let PincodeIsWrong = false
export let PincodeIsOld = false

const msalConfig = {
  auth: {
    clientId: 'bcca688d-725e-4bce-a256-329d2e727e82',
    // authority: 'https://login.microsoftonline.com/8012a67e-5c0d-4fd8-b3bf-dbbfaff82bc5', <- Forkert Iflg Heine Jeppesen (konsulent/apento.com)
    authority: 'https://login.microsoftonline.com/common', // Korrekt Iflg Heine Jeppesen (konsulent/apento.com)
    redirectUri: process.env.VUE_APP_WEB_URL,
    postLogoutRedirectUri: process.env.VUE_APP_WEB_URL
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false
  }
}

// const msalInstance = new PublicClientApplication(msalConfig);  <- newer @azure/msal-browser method, but this old vue isn't compatible
const msalInstance = new Msal.UserAgentApplication(msalConfig)

export async function login (usr) {
  const res = await Backend.callApi({
    apiName: 'Security.LoginUser',
    inputData: {
      UserName: usr.username,
      Password: usr.password,
      PinCode: usr.pincode,
      AccessCode: usr.accessCode
    }
  })
  if (!res.failed) {
    EnterPinCode = false
    PincodeIsWrong = false
    PincodeIsOld = false
    if (process.env.NODE_ENV === 'development') console.log('--> login: ', res)
    user.id = res.data.Id
    user.loggedIn = true
    user.token = res.data.Token
    user.corporation = res.data.Corporation
    user.corporationDetails = res.data.CorporationDetails
    user.userDetails = res.data.UserDetails
    user.name = res.data.Name
    user.fullName = res.data.FullName
    document.title = process.env.VUE_APP_NAME + ' - ' + user.corporation

    // Save this to local storage, so we can support that user is still
    // logged in, even if he reload the page. See also autoLogin()
    LocalStorage.save('user', user)

    startAutoLogout()
    startKeepAlive()

    await loadUserPath()

    // If app exist, we might also have components that would like
    // to re-render according to user status, so send this message.
    if (app != null) app.$emit('force-update')
    await detectDefaultLand()
  } else {
    if (res.data) {
      // The API call did not throw an exception, but the call failed with:
      EnterPinCode = res.data.EnterPinCode
      PincodeIsWrong = res.data.PincodeIsWrong
      PincodeIsOld = res.data.PincodeIsOld
    }
  }
}

export async function loginViaMS () {
  await msalInstance.loginPopup({
    scopes: ['user.read']
  })
    .then(async response => {
      await login({
        username: 'MSLogin',
        password: 'MSLogin',
        pincode: 'MSLogin',
        accessCode: response
      }).then(securityResponse => {
        // TODO: Translation in next line
        // app.$root.$message.showInfo(app.$t('Logged in as:') + ' ' + response.account.name + ' (' + response.account.userName + ')')
        this.loggingIn = false
        this.showEnterPincode = false
      })
    })
    .catch(error => {
      // TODO: How do we handle login error here?  As it is, user is just thrown back to Login view without any message
      app.$root.$message.showError(app.$t('Login failed, please try again. Error: ') + error.message)
    })
}

export async function logout (msLogout) {
  // We tell server to log out (if we have a token)
  if (user.token != null) {
    await Backend.callApi({
      apiName: 'Security.LogoutUser',
      inputData: {
        UserName: user.token.User
      }
    })
  }
  user.id = '00000000-0000-0000-0000-000000000000'
  user.loggedIn = false
  user.token = null
  user.corporation = null
  user.corporationDetails = null
  user.userDetails = null
  user.name = null
  user.fullName = null
  document.title = process.env.VUE_APP_NAME

  LocalStorage.save('user', user)

  // Stop timers
  clearInterval(autoLogOutTimer)
  clearInterval(keepAliveTimer)

  if (msLogout) {
    // console.log('postLogoutRedirectUri:', msalConfig.auth.postLogoutRedirectUri)
    msalInstance.logout()
  } else {
    Router.push('/')

    // If app exist, we might also have components that would like
    // to re-render according to user status.
    if (app != null) app.$emit('force-update')
  }
}

export async function autoLogin () {
  if (!user.loggedIn) {
    const savedUser = LocalStorage.load('user')
    if (process.env.NODE_ENV === 'development') console.log('--> User: ', user)
    if (process.env.NODE_ENV === 'development') console.log('--> Saved user: ', savedUser)
    if (savedUser && savedUser.corporation && savedUser.loggedIn) {
      // found saved user, let's auto log in!
      user.id = savedUser.id
      user.loggedIn = true
      user.token = savedUser.token
      user.corporation = savedUser.Corporation
      user.corporationDetails = savedUser.CorporationDetails
      user.name = savedUser.Name
      user.fullName = savedUser.FullName
      document.title = process.env.VUE_APP_NAME + ' - ' + user.corporation

      // Update token from server
      keepAlive()

      // Start timers
      startAutoLogout()
      startKeepAlive()
    }
  }

  // If app exist, we might also have components that would like
  // to re-render according to user status. We do that with a shourt delay to
  // better ensure that receivers are ready.
  setTimeout(function () { if (app != null) app.$emit('force-update') }, 1000)
}

export async function startAutoLogout () {
  clearInterval(autoLogOutTimer)
  // This performace effect only the client, so time can be pretty small
  autoLogOutTimer = setInterval(autoLogout, 10 * 1000) // Check this every 10 sec
}

export async function startKeepAlive () {
  clearInterval(keepAliveTimer)
  // Keep alive time must be less than user idle time allowd by server
  keepAliveTimer = setInterval(keepAlive, 5 * 60 * 1000) // Check this every 5 mins
}

export async function autoLogout () {
  // Only try if user is logged
  if (user.loggedIn) {
    // If user havent been active for a while, log him out
    if (moment(Date.now()).diff(lastActiveTime, 'seconds') > maxInactiveSec) {
      logout()
    }
  }
}

export async function keepAlive () {
  // Only try if user is logged in or token is not missing
  let logstr = 'keepAlive'
  if (user.loggedIn) {
    logstr = logstr + '. loggedIn'
    if (user.token != null) {
      // Tell server that user is still active.
      logstr = logstr + '. token not null'
      const res = await Backend.callApi({
        apiName: 'Security.Alive'
      })
      if (!res.failed) {
        // Set login data on success
        // Note that server returns a fresh token
        logstr = logstr + '. Alive called ok. loggedIn flag and token updated in LocalStorage.'
        user.id = res.data.Id
        user.loggedIn = true
        user.token = res.data.Token
        user.fullName = res.data.FullName
        user.corporation = res.data.Corporation
        user.corporationDetails = res.data.CorporationDetails
        user.userDetails = res.data.UserDetails
        user.name = res.data.Name
        document.title = process.env.VUE_APP_NAME + ' - ' + user.corporation

        await loadUserPath()

        LocalStorage.save('user', user)
      } else {
        // Logout user on any keepAlive error
        logstr = logstr + '. Alive called failed. logout.'
        logout()
      }
    } else {
      // Logout user if token is missing and user seems to be logged in
      logstr = logstr + '. token null. logout.'
      logout()
    }
  }
  // eslint-disable-next-line no-console
  if (process.env.NODE_ENV === 'development') console.log('--->', logstr, user)
}

// export async function setRedirectTo (route) {
//   redirectTo = route
// }

export function updateLastActiveTime () {
  // Should be called everytime user is touching the UI
  lastActiveTime = Date.now()
}

export function hasAccess (claims) {
  // Returns true if current user has the claims

  // If no claims is needed return true
  if (claims === undefined || claims.length === 0) return true

  let userClaims = null
  if (user.token !== undefined) {
    userClaims = user.token.Claims.map(claim => {
      return claim
    })
  }

  if (userClaims !== undefined) {
    const userHasClaims = claims.some(r => userClaims.includes(r))
    // if (userHasClaims === false) console.log('--> No Claims!', userClaims, claims)
    return userHasClaims
  }

  return false
}

export async function resetPassword (params) {
  const res = await Backend.callApi({
    apiName: 'Security.RequestNewPassword',
    inputData: {
      UserName: params.username,
      NewPassword: params.password
    }
  }, errorHandlingFunc)
  return res
}

async function errorHandlingFunc (error) {
  if (error.response != null && error.response.data != null) {
    app.$root.$message.showError(app.$t(error.response.data.Message))
  } else {
    app.$root.$message.showError(error.message)
  }
}

var lastUsedPathDetail

export async function saveLastPath (path) {
  if (user && user.id && user.loggedIn) {
    if (process.env.NODE_ENV === 'development') console.log('--> saveLastPath: ', lastUsedPathDetail)
    if (lastUsedPathDetail.Value !== path) { // Do not save if same path
      lastUsedPathDetail.Value = path
      const saveRes = await lastUsedPathDetail.save()
      if (saveRes.data) {
        lastUsedPathDetail = new UserDetail(saveRes.data)
      }
    }
  }
}

// temporarly store direct path links, and go to direct path instead of saved path in loadUserPath
export async function saveDirectPath (path) {
  goToDirectPath = path
}

async function loadUserPath () {
  if (user && user.id && user.loggedIn) {
    lastUsedPathDetail = await UserDetail.load(user.id, 'LastUsedPath')
    if (process.env.NODE_ENV === 'development') console.log('--> loadUserPath: ', lastUsedPathDetail)
    if (process.env.NODE_ENV === 'development') console.log('--> loadUserPath, current route: ', window.location.pathname)

    if (lastUsedPathDetail && lastUsedPathDetail.Value) {
      if (window.location.pathname !== lastUsedPathDetail.Value) {
        // Support direct path links, when user is logged in
        if (goToDirectPath) {
          Router.push(goToDirectPath); goToDirectPath = null
        } else {
          Router.push(lastUsedPathDetail.Value)
        }
      }
    } else {
      if (user.ConfigNeeded) {
        Router.push('/userconfigneeded')
      } else {
        // Check if user has "single module" installed, and if yes, go to this menu item (only on first time login)
        var goToSingleModulePath = await goToSingleModule()
        if (goToSingleModulePath) { Router.push(goToSingleModulePath) } else { Router.push('/welcome') }
      }
    }
  } else {
    Router.push('/welcome')
  }
}

export async function resendPinCode (params) {
  const res = await Backend.callApi({
    apiName: 'Security.ResendPinCode',
    inputData: {
      UserName: params.username
    }
  })
  return res
}

// adminNo = '10'
// corporateAdminNo = '40'
// deliveryInspectionNo = '69171005'
// wheelLoaderNo = '69171010'
// asphaltDeliveryVehicleNo = '691710201'
// asphaltDeliveryCarrierNo = '691710202'
// preRegistrationNo = '69171025'
// classifierNo = '69171030'
// scanCodeNo = '69171035'

export async function goToSingleModule () {
  var path = ''
  if (user.token.Claims.some(c => c.length <= 2)) {
    path = '' // Never goto singe module for admin claims (1,10,20,30,40)
  } else {
    // Filter out Paths without claims, admin claims (10,40) or root paths (with a single /)
    var singleModulePaths = Router.options.routes.filter(r => r.meta && r.meta.claims &&
        (!(r.meta.claims.includes(License.adminNo) || r.meta.claims.includes(License.corporateAdminNo)) && r.path.split('/').length - 1 === 1))
    var userClaims = user.token.Claims.filter(c => c.length > 2) // Filter out admin claims (1,10,20,30,40)
    var countUnique = 0
    var foundPath = ''
    // Find any path with claims matching userClaims
    singleModulePaths.forEach(item => {
      if (item.meta.claims) { item.meta.claims.forEach(claim => { if (userClaims.includes(claim)) { countUnique += 1; foundPath = item.path } }) }
    })
    // If only one path found, use it
    if (countUnique === 1) path = foundPath

    if (process.env.NODE_ENV === 'development') {
      console.log('> > > AllClaims', user.token.Claims)
      console.log('> > > UserClaims', userClaims)
      console.log('> > > Module paths', singleModulePaths)
      console.log('> > > countUnique, foundPath', countUnique, foundPath)
    }
  }
  return path
}
